module.exports = __webpack_public_path__ + "static/media/Read-Blogs.8d5ac24e.svg";